import React, {useState} from 'react';
import {useForm} from "react-hook-form";
import * as forms from "./forms.module.scss";

const ContactMeForm = () => {

  const [isSubmitted, setSubmitted] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: {errors},
  } = useForm();

  // Encode fields function
  const encode = (data) => {

    const formData = new FormData();

    Object.keys(data).map(key => {
      if (key === 'files') {
        for (const file of data[key]) {
          formData.append(key, file, file.name)
        }
      } else {
        formData.append(key, data[key])
      }
    })

    // Set form name
    formData.append('formName', 'Kennismaken: tpf.nu');

    return formData
  }

  // Handle submit
  const onSubmit = (data) => {

    setSubmitting(true);

    const encodedBodyData = encode(data);

    fetch(`/api/simple-contact-form-handler`, {
      method: `POST`,
      body: encodedBodyData,
    })
      .then(res => res.json())
      .then(data => {
        // Error
        if (data.error) {
          alert(data.error);
          setSubmitting(false);
        } else {
          // Success
          setSubmitting(false);
          setSubmitted(true);
          reset();
        }
      });
  }

  const thankYou = (
    <div className="msg-confirm has-success">
      <p>Bedankt! Je bericht is verzonden.</p>
    </div>
  );

  const form = (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={`${forms.inputWrapper} ${errors.naam && `has-error`}`}>
        <label className="control-label sr-only" htmlFor="naam">Naam *</label>
        <input
          placeholder="Naam *"
          className="form-control"
          id="naam"
          type="text"
          maxLength="80"
          disabled={isSubmitting}
          {...register("naam", {
            required: true,
            maxLength: 80
          })}
        />
        {errors.naam && <div className="msg-error">Dit veld is verplicht</div>}
      </div>

      <div className={`${forms.inputWrapper} ${errors.e__mailadres && `has-error`}`}>
        <label className="control-label sr-only" htmlFor="e__mailadres">E-mailadres *</label>
        <input
          placeholder="E-mailadres *"
          className="form-control"
          id="e__mailadres"
          type="email"
          disabled={isSubmitting}
          {...register("e__mailadres", {
            required: true,
            pattern: /^\S+@\S+$/i
          })}
        />
        {errors.e__mailadres && <div className="msg-error">Dit veld is verplicht</div>}
      </div>

      <div className={`${forms.inputWrapper}`}>
        <label className="control-label sr-only" htmlFor="telefoonnummer">Telefoonnummer</label>
        <input
          placeholder="Telefoonnummer"
          className="form-control"
          id="telefoonnummer"
          type="tel"
          minLength="6"
          maxLength="14"
          disabled={isSubmitting}
          {...register("telefoonnummer", {
            minLength: 6,
            maxLength: 14,
          })}
        />
      </div>

      <div className={`${forms.inputWrapper} ${errors.website && `has-error`}`}>
        <label className="control-label sr-only" htmlFor="website">Website</label>
        <input
          placeholder="Website"
          className="form-control"
          id="website"
          type="text"
          minLength="3"
          maxLength="200"
          disabled={isSubmitting}
          {...register("website", {

          })}
        />
      </div>

      <div className={forms.honingHommelWrapper}>
        <label htmlFor="name_hon">Name</label>
        <input tabIndex="-1" autoComplete="false"
               id="name_hon"
               type="name_hon"
               disabled={isSubmitting}
               {...register("name_hon", {})}
        />

        <label htmlFor="email_hon">Email</label>
        <input tabIndex="-1" autoComplete="false"
               id="email_hon"
               type="email_hon"
               disabled={isSubmitting}
               {...register("email_hon", {})}
        />
      </div>

      <button className="btn btn-primary" type="submit" disabled={isSubmitting}>
        Versturen
      </button>

    </form>
  );

  return (
    <div className="contact-me-form">
      {isSubmitted ? thankYou : ''}
      {form}
    </div>
  );
};

export default ContactMeForm;